import { withTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { NS } from '@/constants';
import { useAppDispatch } from '@/redux';
import { addToast } from '@/redux/slices/toast.slice';
import { useServices } from '@/services/useServices';
import styles from './FooterNewsletterForm.module.scss';
import NewsletterValidator from './NewsletterValidator';

export const FooterNewsletterForm = ({ t, storeId }) => {
	const { newsletterService } = useServices();
	const dispatch = useAppDispatch();
	const [response, setResponse] = useState(undefined);

	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();

	const submitNewsletter = async ({ email }) => {
		const data = await newsletterService.newsletterSubscribe(storeId, email);
		setResponse(data);
	};

	useEffect(() => {
		if (response === undefined) {
			return;
		}
		if (response.success) {
			dispatch(addToast({ msg: t('footer.keepContact.newsletter.subscribeSuccess'), err: false }));
		} else {
			dispatch(addToast({ msg: t('footer.keepContact.newsletter.subscribeFailure') }));
		}
		reset();
	}, [response]);

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<div className={styles.title}>{t('footer.newsletter.joinUs')}</div>

				<div className={`mt-3 ${styles.description}`}>{t('footer.newsletter.longDescription')}</div>

				<form onSubmit={handleSubmit(submitNewsletter)} id="newsletterForm" name="newsletterForm">
					<NewsletterValidator
						id="newsletterEmail"
						type="email"
						title={t('forms.email')}
						placeholder={t('footer.newsletter.yourEmailAddress')}
						btn={t('btn.subscribe')}
						error={errors.email?.message}
						className="flex-grow-1 mr-2 input-text required-entry validate-email"
						{...register('email', {
							required: t('forms.requiredField'),
							pattern: {
								value: /\S+@\S+\.\S+/,
								message: `${t('forms.validEmail')} ${t('forms.validEmailExample')}`,
							},
						})}
					/>
				</form>
			</div>
		</div>
	);
};

FooterNewsletterForm.propTypes = {
	storeId: PropTypes.string.isRequired,
	t: PropTypes.func.isRequired,
};

export default withTranslation(NS.COMMON)(FooterNewsletterForm);
